module.exports = __webpack_public_path__ + "img/Christine_Mondhygieniste.86b52ff9.png";